import { createContext, useContext } from "react";
import { IWorkspaceMember } from "dto/IWorkspace";
import {
  DEFAULT_WIZARD_SETTINGS,
  EWizardStep,
  IContactFormWizardSettings,
  WizardSettingsPatch,
} from "./typings";

export interface IWizardContextValue {
  settings: IContactFormWizardSettings;
  patchSettings: (patch: WizardSettingsPatch) => void;
  members: IWorkspaceMember[];

  currentStep: EWizardStep;
  expandedStep: EWizardStep | null;
  goToStep: (step: EWizardStep) => void;
  toggleStep: (step: EWizardStep) => void;
  goNext: () => void;
  goBack: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;

  isSaving: boolean;
  isUploadingLogo: boolean;
  stepDirty: boolean;
  inline: boolean;

  logoKey?: string;
  uploadLogo: (file: File) => void;
  deleteLogo: () => void;

  finish: () => void;
}

export const WizardContext = createContext<IWizardContextValue>({
  settings: DEFAULT_WIZARD_SETTINGS,
  patchSettings: () => {},
  members: [],
  currentStep: EWizardStep.FormStyle,
  expandedStep: EWizardStep.FormStyle,
  goToStep: () => {},
  toggleStep: () => {},
  goNext: () => {},
  goBack: () => {},
  isFirstStep: true,
  isLastStep: false,
  isSaving: false,
  isUploadingLogo: false,
  stepDirty: false,
  inline: false,
  logoKey: undefined,
  uploadLogo: () => {},
  deleteLogo: () => {},
  finish: () => {},
});

export const useWizard = () => useContext(WizardContext);
